var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28147",
    "data-name": "Group 28147",
    transform: "translate(-1235.999 -321.909)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1235.999 321.909)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_clipboard-text",
    "data-name": "vuesax/bold/clipboard-text",
    transform: "translate(1132.256 74.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text",
    transform: "translate(108 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.448,0H1.276A1.273,1.273,0,0,0,0,1.269V1.9A1.268,1.268,0,0,0,1.269,3.173H4.448A1.268,1.268,0,0,0,5.717,1.9V1.269A1.263,1.263,0,0,0,4.448,0Z",
    transform: "translate(5.238 1.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9.416.5A1.956,1.956,0,0,1,7.466,2.449H4.293A1.956,1.956,0,0,1,2.342.5.5.5,0,0,0,1.6.059,3.018,3.018,0,0,0,0,2.725V9.077a3.025,3.025,0,0,0,3.017,3.017H8.741a3.025,3.025,0,0,0,3.017-3.017V2.725a3.018,3.018,0,0,0-1.6-2.666A.5.5,0,0,0,9.416.5ZM6.136,8.686H3.179a.506.506,0,0,1,0-1.013H6.136a.506.506,0,0,1,0,1.013ZM7.9,5.986H3.179a.506.506,0,0,1,0-1.013H7.9a.506.506,0,0,1,0,1.013Z",
    transform: "translate(2.221 2.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H16.2V16.2H0Z",
    transform: "translate(16.2 16.2) rotate(180)",
    fill: "none",
    opacity: 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCircle);
export default __webpack_public_path__ + "static/media/document-circle.578164d450e441a18d2a96a436b31e79.svg";
export { ForwardRef as ReactComponent };